import { useMemo } from "react";
export const useChargeHistoryStatusEntries = (statuses) => {
    return useMemo(() => {
        if (!statuses)
            return [];
        // Map of status keys to display labels and colors (handle both case variations)
        const statusConfig = {
            available: { color: "#0066FF", label: "Available" },
            charging: { color: "#1AC69E", label: "Charging" },
            faulted: { color: "#FB5A00", label: "Faulted" },
            finishing: { color: "#9370DB", label: "Finishing" },
            offline: { color: "#E1E1E1", label: "Offline" },
            preparing: { color: "#FFA500", label: "Preparing" },
            reserved: { color: "#FFD700", label: "Reserved" },
            suspendedEV: { color: "#FF6347", label: "Suspended EV" }, // API uses capital EV
            suspendedEv: { color: "#FF6347", label: "Suspended EV" },
            suspendedEvse: { color: "#FF4500", label: "Suspended EVSE" },
            unavailable: { color: "#A9A9A9", label: "Unavailable" },
            unknown: { color: "#808080", label: "Unknown" }
        };
        // Only show these specific statuses
        const allowedStatuses = ["charging", "available", "faulted", "offline"];
        return Object.entries(statuses)
            .filter(([key, value]) => {
            // Only include allowed statuses
            if (!allowedStatuses.includes(key.toLowerCase()))
                return false;
            // Exclude lastReportedTimestamp (string type) and focus on status objects
            if (key === "lastReportedTimestamp" || typeof value === "string")
                return false;
            // Only include statuses with valid value property
            const hasValue = value && typeof value === "object" && "value" in value;
            const valueNum = hasValue ? value.value : undefined;
            return hasValue && typeof valueNum === "number";
        })
            .map(([key, value]) => {
            const minutes = value.value;
            const hours = minutes / 60; // Convert minutes to hours inline
            return {
                color: statusConfig[key]?.color || "#808080",
                key,
                label: statusConfig[key]?.label || key.charAt(0).toUpperCase() + key.slice(1),
                value: hours
            };
        });
    }, [statuses]);
};
